<ion-fab vertical="bottom" horizontal="start" slot="fixed" *ngIf="auth.user | async as user">
  <ion-fab-button color="tertiary" *ngIf="!user.welcome">
    <ion-icon color="white" src="assets/icons/add.svg"></ion-icon>
  </ion-fab-button>
  <ion-fab-list side="end">
    <ion-fab-button *ngIf="user.giglister" routerLink="/account/gigs/create">
      <ion-icon color="primary" src="assets/icons/gigs.svg"></ion-icon>
    </ion-fab-button>
    <ion-fab-button *ngIf="user.joblister" routerLink="/account/jobs/create">
      <ion-icon color="primary" src="assets/icons/jobs.svg"></ion-icon>
    </ion-fab-button>
    <ion-fab-button *ngIf="user.volseeker" routerLink="/account/volunteers/create">
      <ion-icon color="primary" src="assets/icons/volunteers.svg"></ion-icon>
    </ion-fab-button>
    <ion-fab-button *ngIf="user.promoter" routerLink="/account/promote/create">
      <ion-icon color="primary" src="assets/icons/promote.svg"></ion-icon>
    </ion-fab-button>
  </ion-fab-list>
</ion-fab>
